import React from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { connect } from 'react-redux';
import { storeWithExpiration } from '../../utils/common';
import {
  EDIT_GROUP_PAGE,
  EDIT_SKU_PAGE,
  FIELDSET_TYPE_GROUP,
  FIELDSET_TYPE_SKU,
  NEW_GROUP_PAGE,
  RECORD_LEVEL_TYPE_COMPANY,
  RECORD_LEVEL_TYPE_CONTACT,
  RECORD_LEVEL_TYPE_ITEM,
} from '../../config/app_config';
import FieldsetCreateEdit from './FieldsetCreateEdit';
import {
  cancelGroupSKU,
  createNewFieldset,
  deleteSku,
  fetchFieldsetsById,
  fetchFilesets,
  fetchGroupFieldsById,
  fetchSingleDatasetById,
  listFields,
  openEditSku,
  resetPage,
  setCurrentDataset,
  updateFieldSetFields,
  updateSku,
  updateSkuProps,
} from '../../actions/data';
import { openDialog, closeDialog } from '../../actions/dialog';
import Dialog from '../shared/Dialog';

export class FieldsetCreateEditContainer extends React.Component {
  static propTypes = {
    cancelAddEditAction: PropTypes.func.isRequired,
    closeDialogAction: PropTypes.func.isRequired,
    companyDatasetFields: PropTypes.object,
    contactDatasetFields: PropTypes.object,
    createNewFieldsetAction: PropTypes.func.isRequired,
    currDataset: PropTypes.object,
    currentFields: PropTypes.object,
    currentFieldset: PropTypes.object,
    datasetId: PropTypes.string.isRequired,
    deleteSkuAction: PropTypes.func.isRequired,
    dialog: PropTypes.object.isRequired,
    fetchFieldsetsByIdAction: PropTypes.func.isRequired,
    fetchFilesetsAction: PropTypes.func.isRequired,
    fetchGroupFieldsByIdAction: PropTypes.func.isRequired,
    fetchSingleDatasetByIdAction: PropTypes.func.isRequired,
    fieldsetId: PropTypes.string,
    groupFields: PropTypes.object.isRequired,
    groups: PropTypes.object.isRequired,
    initialValues: PropTypes.object, // Gets used in the edit pages as part of redux form (Don't delete)
    isAdminPage: PropTypes.bool.isRequired,
    isEdit: PropTypes.bool.isRequired,
    isGroup: PropTypes.bool.isRequired,
    itemDatasetFields: PropTypes.object,
    listFieldsAction: PropTypes.func.isRequired,
    openDialogAction: PropTypes.func.isRequired,
    openEditFieldsetAction: PropTypes.func.isRequired,
    progress: PropTypes.number.isRequired,
    updateFieldSetFieldsAction: PropTypes.func.isRequired,
    updateSkuPropsAction: PropTypes.func.isRequired,
  };

  static defaultProps = {
    companyDatasetFields: null,
    contactDatasetFields: null,
    currDataset: null,
    currentFields: null,
    currentFieldset: null,
    fieldsetId: '',
    initialValues: null,
    itemDatasetFields: null,
  };

  constructor(props) {
    super(props);
    this.cancelDialog = this.cancelDialog.bind(this, 'confirmDeleteFieldset');
  }

  componentWillMount = () => {
    const {
      datasetId,
      fetchFieldsetsByIdAction,
      fetchFilesetsAction,
      fetchSingleDatasetByIdAction,
      fieldsetId,
      isAdminPage,
      isEdit,
      listFieldsAction,
      openEditFieldsetAction,
    } = this.props;
    const token = storeWithExpiration.get('token');
    // Get all fields for the dataset
    listFieldsAction(datasetId, token, null);
    fetchFieldsetsByIdAction(datasetId, undefined, token); // undefined gets 'SKU' and 'GROUPS'
    fetchSingleDatasetByIdAction(datasetId, token, true);
    fetchFilesetsAction(datasetId, token);

    if (isEdit) {
      const datasetName = '';
      openEditFieldsetAction(token, fieldsetId, datasetId, datasetName, isAdminPage);
    }
  };

  componentWillReceiveProps = newProps => {
    const { currentFieldset } = newProps;
    if (currentFieldset && currentFieldset.installedCount > 0) browserHistory.push('/data');
  };

  toggleDialog = id => {
    const { dialog, openDialogAction, closeDialogAction } = this.props;
    if (dialog.show) {
      closeDialogAction(id);
    } else {
      openDialogAction(id);
    }
  };

  cancelDialog = id => {
    const { closeDialogAction } = this.props;
    closeDialogAction(id);
  };

  cancelAddEdit = isFormDirty => {
    const { cancelAddEditAction, datasetId } = this.props;
    if (isFormDirty) {
      // eslint-disable-next-line
      if (window.confirm('You are about to lose your changes, are you sure you want to leave?')) {
        cancelAddEditAction(datasetId);
      }
    } else {
      cancelAddEditAction(datasetId);
    }
  };

  createFieldset = (params, fieldsInFieldset) => {
    const { createNewFieldsetAction, datasetId, isGroup } = this.props;
    const token = storeWithExpiration.get('token');
    const fieldsetType = isGroup ? FIELDSET_TYPE_GROUP : FIELDSET_TYPE_SKU;
    const fieldsetName = params.fieldsetName.trim();
    createNewFieldsetAction(datasetId, fieldsInFieldset, fieldsetName, fieldsetType, token);
  };

  updateFieldset = (params, updatedFieldsInFieldset) => {
    const {
      updateFieldSetFieldsAction,
      currentFields,
      currentFieldset,
      isAdminPage,
      isGroup,
      datasetId,
      updateSkuPropsAction,
    } = this.props;

    if (currentFieldset.installedCount > 0) {
      this.toggleDialog('editSkuDialog2');
    } else {
      const token = storeWithExpiration.get('token');
      const { fieldsetName } = params;
      const fieldsetType = isGroup ? FIELDSET_TYPE_GROUP : FIELDSET_TYPE_SKU;

      if (currentFieldset.name !== fieldsetName) {
        const fieldsetInfo = {
          id: currentFieldset.id,
          name: fieldsetName,
          setType: currentFieldset.setType,
          status: currentFieldset.status,
        };
        updateSkuPropsAction(token, datasetId, fieldsetInfo);
      }

      updateFieldSetFieldsAction(
        currentFieldset.id,
        datasetId,
        currentFields,
        updatedFieldsInFieldset,
        fieldsetType,
        isAdminPage,
        token
      );
    }
  };

  confirmDeleteFieldset = () => {
    const { currentFieldset } = this.props;
    if (currentFieldset.orderCount > 0) {
      this.toggleDialog('editSkuDialog2');
    } else {
      this.toggleDialog('confirmDeleteFieldset');
    }
  };

  deleteFieldset = () => {
    const { currentFieldset, datasetId, deleteSkuAction, isAdminPage, isGroup } = this.props;
    const token = storeWithExpiration.get('token');
    const prom = new Promise(resolve => {
      const fieldsetType = isGroup ? FIELDSET_TYPE_GROUP : FIELDSET_TYPE_SKU;
      deleteSkuAction(token, currentFieldset.id, datasetId, fieldsetType, isAdminPage, resolve);
    });
    prom.then(() => {
      this.cancelDialog('confirmDeleteFieldset');
    });
  };

  renderDeleteSkuDialog = () => {
    const { dialog, currentFieldset, isGroup } = this.props;

    const content = (
      <div className="container">
        <p>
          Are you sure you want to delete the
          {isGroup ? ' Group' : ' SKU'} {currentFieldset.get('name')}?
        </p>
      </div>
    );

    return (
      <Dialog
        cancelFunction={this.cancelDialog}
        cancelText="Cancel"
        content={content}
        id="confirmDeleteFieldset"
        show={dialog.show}
        successText="Yes"
        successFunction={() => this.deleteFieldset()}
        title={isGroup ? 'Delete Group' : 'Delete SKU'}
      />
    );
  };

  render() {
    const {
      companyDatasetFields,
      contactDatasetFields,
      currDataset,
      currentFields,
      currentFieldset,
      dialog,
      fetchGroupFieldsByIdAction,
      groupFields,
      groups,
      initialValues,
      isEdit,
      isGroup,
      itemDatasetFields,
      progress,
    } = this.props;
    const hasOrder = currentFieldset && currentFieldset.orderCount > 0;
    return !isEdit || (isEdit && currentFieldset) ? (
      <div className="modal-wrap">
        <div className="container-fluid container-home">
          <div className="header">
            <div className="header-body">
              <div className="row">
                <div className="col-sm-12">
                  <h1 className="header-title">
                    {isEdit ? 'Edit ' : 'New '}
                    {isGroup ? 'Group' : 'SKU'}
                  </h1>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12">
              <FieldsetCreateEdit
                cancelAddEdit={this.cancelAddEdit}
                companyDatasetFields={companyDatasetFields}
                contactDatasetFields={contactDatasetFields}
                currDataset={currDataset}
                currentFields={currentFields}
                deleteFieldsetFunction={this.confirmDeleteFieldset}
                fetchGroupFieldsByIdFunction={fetchGroupFieldsByIdAction}
                groupFields={groupFields}
                groups={groups}
                hasOrder={hasOrder}
                initialValues={initialValues}
                isEdit={isEdit}
                isGroup={isGroup}
                itemDatasetFields={itemDatasetFields}
                progress={progress}
                submitFunction={isEdit ? this.updateFieldset : this.createFieldset}
              />
            </div>
          </div>
        </div>
        {dialog.show && dialog.id === 'editSkuDialog2' ? this.renderEditSkuDialog() : null}
        {dialog.show && dialog.id === 'confirmDeleteFieldset' ? this.renderDeleteSkuDialog() : null}
      </div>
    ) : null;
  }
}

const mapStateToProps = (state, ownProps) => {
  const { data, dialog, account, progress } = state;
  const { page, datasetId, fieldsetId } = ownProps;
  const currDataset = data.get('dataset');
  const currentFields = data.get('currentSkuFields');
  const datasetFields = data.get('fields');
  const isEdit = page === EDIT_GROUP_PAGE || page === EDIT_SKU_PAGE;
  const skuIsInUse = data.get('skuIsInUse');
  const isAdminPage = data.get('isAdminPage');
  const groupFields = data.get('currentGroupFields');
  const fieldsets = data.get('fieldSets');
  const currentFilesets = data.get('currentFilesets'); // Two sets, one for company, one for contact
  let currentFieldset; // const currentSku = data.get('currentSkuInfo');
  let groups;
  function getRecordLevelType(field) {
    const filesetId = field.get('filesetId');
    const fileSet = currentFilesets.get(`${filesetId}`);

    return fileSet ? fileSet.get('recordLevelType') : '';
  }

  if (fieldsets) {
    groups = fieldsets.filter(fieldset => fieldset.setType === FIELDSET_TYPE_GROUP);
    if (fieldsetId) {
      currentFieldset = fieldsets
        .filter(fieldset => fieldset.get('id') === parseInt(fieldsetId, 10))
        .first();
    }
  }
  let initialValues = { fieldsetName: '' };
  if (currentFieldset) {
    initialValues = { fieldsetName: currentFieldset.get('name') };
  }
  let companyDatasetFields;
  let contactDatasetFields;
  let itemDatasetFields;
  if (currentFilesets !== undefined && currentFilesets.size > 0) {
    if (datasetFields !== undefined && datasetFields.size > 0) {
      companyDatasetFields = datasetFields.filter(field => {
        const recordLevelType = getRecordLevelType(field);
        return recordLevelType === RECORD_LEVEL_TYPE_COMPANY;
      });
      contactDatasetFields = datasetFields.filter(field => {
        const recordLevelType = getRecordLevelType(field);
        return recordLevelType === RECORD_LEVEL_TYPE_CONTACT;
      });
      itemDatasetFields = datasetFields.filter(field => {
        const recordLevelType = getRecordLevelType(field);
        return recordLevelType === RECORD_LEVEL_TYPE_ITEM;
      });
    }
  }
  const isGroup = page === NEW_GROUP_PAGE || page === EDIT_GROUP_PAGE;

  return {
    account,
    companyDatasetFields,
    contactDatasetFields,
    currDataset,
    currentFields,
    currentFieldset,
    currentFilesets,
    datasetFields,
    datasetId,
    dialog,
    fieldsetId,
    fieldsets,
    groupFields,
    groups,
    initialValues,
    isAdminPage,
    isEdit,
    isGroup,
    itemDatasetFields,
    page,
    progress,
    skuIsInUse,
  };
};

export default connect(mapStateToProps, {
  cancelAddEditAction: cancelGroupSKU,
  closeDialogAction: closeDialog,
  createNewFieldsetAction: createNewFieldset,
  deleteSkuAction: deleteSku,
  fetchFieldsetsByIdAction: fetchFieldsetsById,
  fetchFilesetsAction: fetchFilesets,
  fetchGroupFieldsByIdAction: fetchGroupFieldsById,
  fetchSingleDatasetByIdAction: fetchSingleDatasetById,
  listFieldsAction: listFields,
  openDialogAction: openDialog,
  openEditFieldsetAction: openEditSku,
  resetPageAction: resetPage,
  setCurrentDatasetAction: setCurrentDataset,
  updateFieldSetFieldsAction: updateFieldSetFields,
  updateSkuAction: updateSku,
  updateSkuPropsAction: updateSkuProps,
})(FieldsetCreateEditContainer);
